/**
 * Chailease.SystemManagement.API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * 員工職稱資料
 */
export interface PermissionUserJobTitleViewModel { 
    /**
     * 員工職稱資料ID
     */
    userJobTitleId?: number;
    /**
     * 部門資料ID
     */
    departmentId?: number;
    /**
     * 是否為主要職務
     */
    mainDuty?: boolean;
    /**
     * 職位權重
     */
    priority?: number;
    /**
     * 優先職位權重
     */
    firstPriority?: boolean;
}